<template>
	<div class="panel panel-product product-list-compact-item" style="position: relative">
		<a v-if="showRemoveButton" class="feed-remove-icon" @click.prevent.stop="removeProduct(product)">
			<span class="glyphicon glyphicon-remove" />
		</a>
		<div class="panel-body product-list-compact-wrap">
			<product-link :product="product" :pass="product.pass" class="compact-product-image image-link">
				<ximg :src="src" :ariaLabel="product.name" eager role="img" />
			</product-link>
			<div class="px-3 relative" style="width: 100%; min-width: 0; white-space: normal">
				<product-link :product="product" :pass="product.pass">
					<fixed-lines :useEllipsis="false" :lines="2" class="mb-3-sm">
						{{ product.name }}
					</fixed-lines>
				</product-link>
			</div>
		</div>
	</div>
</template>
<script>
import { convertToCdnUrl } from 'utils';
import store from 'datastore';
import { t } from 'datastore/i18n';

export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		showRemoveButton: {
			type: Boolean,
			required: false,
			default: true,
		}
	},
	data () {
		return {
			convertToCdnUrl,
			energyMarkingModal: false,
		};
	},
	methods: {
		t,
		tp: t.prefix('PRODUCT'),
		removeProduct (product) {
			store.commit('viewHistory/removeProduct', product);
		},
	},
	computed: {
		src () {
			return convertToCdnUrl('/images/product/' + this.product.id + '?trim&h=80');
		},
	},
};
</script>
